var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2716)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_2716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 6H14C11.7909 6 10 7.79086 10 10V28C10 30.2091 11.7909 32 14 32H32C34.2091 32 36 30.2091 36 28V10C36 7.79086 34.2091 6 32 6Z",
    fill: "#76B12B"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.0001 2H14.0001C11.791 2 10.0001 3.79086 10.0001 6V24C10.0001 26.2091 11.791 28 14.0001 28H32.0001C34.2093 28 36.0001 26.2091 36.0001 24V6C36.0001 3.79086 34.2093 2 32.0001 2Z",
    fill: "#9DC724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0806 20.15C17.2706 20.15 16.6506 19.92 16.2206 19.46C15.7906 19 15.5756 18.35 15.5756 17.51V11.99C15.5756 11.15 15.7906 10.5 16.2206 10.04C16.6506 9.58 17.2706 9.35 18.0806 9.35C18.8906 9.35 19.5106 9.58 19.9406 10.04C20.3706 10.5 20.5856 11.15 20.5856 11.99V17.51C20.5856 18.35 20.3706 19 19.9406 19.46C19.5106 19.92 18.8906 20.15 18.0806 20.15ZM18.0806 18.65C18.6506 18.65 18.9356 18.305 18.9356 17.615V11.885C18.9356 11.195 18.6506 10.85 18.0806 10.85C17.5106 10.85 17.2256 11.195 17.2256 11.885V17.615C17.2256 18.305 17.5106 18.65 18.0806 18.65ZM21.7014 18.41H23.2914V20H21.7014V18.41ZM26.9436 20.15C26.1436 20.15 25.5336 19.925 25.1136 19.475C24.6936 19.015 24.4836 18.36 24.4836 17.51V16.685H26.0436V17.63C26.0436 18.31 26.3286 18.65 26.8986 18.65C27.4686 18.65 27.7536 18.31 27.7536 17.63V15.275C27.7536 14.585 27.4686 14.24 26.8986 14.24C26.3286 14.24 26.0436 14.585 26.0436 15.275V15.365H24.4836L24.7836 9.5H29.1336V11H26.2536L26.1186 13.505H26.1486C26.4586 12.995 26.9336 12.74 27.5736 12.74C28.1736 12.74 28.6286 12.945 28.9386 13.355C29.2486 13.765 29.4036 14.36 29.4036 15.14V17.51C29.4036 18.36 29.1936 19.015 28.7736 19.475C28.3536 19.925 27.7436 20.15 26.9436 20.15Z",
    fill: "#111820"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_2716",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_2716"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_2716",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2716"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg05);
export default __webpack_public_path__ + "static/media/05.c0e7ce31ce1c3e79ada96bd8c9f08c3c.svg";
export { ForwardRef as ReactComponent };